
const milestonesData= {
	title: "Investment approach",
	description: [
		'The Tutuwa Foundation’s investment approach is driven by a commitment to reshaping development pathways through strategic action and calculated risk-taking. Recognising that meaningful impact requires more than funding, Tutuwa actively seeks to catalyse innovation, build collaborative networks and drive systemic change. By investing in bold solutions, fostering enduring partnerships and championing new ways of thinking, the Foundation ensures its contributions extend beyond individual projects - creating scalable, sustainable transformation in the sectors it serves.',
		'By working alongside government, civil society and private sector actors, the Foundation strengthens programmes and influences development ecosystems, ensuring impactful interventions are expanded and sustained for long-term social change. Active participation in the governance structures of these collaborative bodies is equally critical - allowing Tutuwa to contribute meaningfully to knowledge sharing, learning exchanges and the co-creation of solutions.',
	],
	background: {
		desktop: "/assets/images/intro-banner/intro-banner.png",
		mobile: "/assets/images/intro-banner/intro-banner-mobi.png",
		alt: "",
	},
	image: {
		src: "/assets/images/milestones.jpg",
		alt: "",
	},
	event: [
		{
			year: "2004",
			title: '"The SBG’s black ownership initiative, known as Tutuwa, launches ',
			description: "Shares priced at R42.50 per share",
		},
		{
			year: "2006",
			title: 'SMME participants join the scheme',
			description: "250 small- and medium-sized enterprises are selected",
		},
		{
			year: "2008",
			title: 'Shares sold to the Industrial and Commercial Bank of China (ICBC)',
			description: "The ICBC bought 11.11% of shares as part of its acquisition of 20% of SBG",
		},
		{
			year: "2010",
			title: 'The start of dividend payments to beneficiaries',
			description: "Tutuwa Managers Trust shares vest fully",
		},
		{
			year: "2010",
			title: 'Dividend payments continue',
			description: "R1.9bn dividends distributed to all Tutuwa beneficiaries",
		},

		{
			year: "2014",
			title: 'Tutuwa’s ten year lock-in period ends',
			description: "Shares priced at R143.48 per share",
		},
		{
			year: "2015",
			title: 'Tax paid on behalf of Managers Trust beneficiaries',
			description: "More than R1 billion in PAYE paid over to SARS",
		},
		{
			year: "2015",
			title: 'SMMEs exit scheme',
			description: "More than R10.7 billion created for beneficiaries",
		},
		{
			year: "2016",
			title: '',
			description: "High-school Scholarship Programme launches",
		},
		{
			year: "2019",
			title: 'The Tutuwa scheme ends',
			description: "All remaining debt is settled",
		},
		{
			year: "2021",
			title: 'Our Foundation’s inception strategy comes to an end',
			description: "New 2021-2025 strategy implemented",
		},
	]

};

export { milestonesData };
